import { css } from '@emotion/core'

export default css({
	label: 'elevated',
	boxShadow: '0 1.5px 4px rgba(0, 0, 0, 0.24), 0 0.5px 2px rgba(0, 0, 0, 0.19)',
})
